import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确 定")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_dialog, {
      title: "敏感字段",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.dialogVisible = $event)),
      width: "30%",
      "close-on-click-modal": _ctx.clickModalClose,
      "before-close": _ctx.cancel
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_1, [
          _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.addSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_checkbox_group, {
          modelValue: _ctx.fields,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.fields = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sensitiveFields, (item) => {
              return (_openBlock(), _createBlock(_component_el_checkbox, {
                label: item.fieldName,
                key: item.fieldName
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.description), 1 /* TEXT */)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "close-on-click-modal", "before-close"])
  ]))
}